import { DumQueryApi } from '@src/Api/generated-global-event';
import { useStores } from '@src/Common/Hooks/useStores';
import AxiosInstanceGlobalEvent from '@src/Common/Services/Api/AxiosInstanceGlobalEvent';
import { IDumFilter } from '@src/Domain/AdvanceFilter/AdvanceFilterStore';
import { AxiosInstance } from 'axios';
import { useEffect, useState } from 'react';
const lDEQa = (AI: AxiosInstance) => new DumQueryApi(undefined, '', AI);
const useAdvanceFilter = () => {
  const { DUMEventStore, AdvanceFilterStore } = useStores();
  const [showAnomalyCard, setShowAnomalyCard] = useState<boolean>(false);

  const [minMaxYear, setMinMaxYear] = useState<number[]>([0, 0]);
  const [filters, setFilters] = useState<IDumFilter>({
    ...AdvanceFilterStore.filters
  });

  const onStartYearChange = (v: number) => {
    setFilters((s) => ({
      ...s,
      year: {
        ...s.year,
        from: v
      }
    }));
    if (filters.year.end && v > filters.year.end) {
      onEndYearChange(v);
    }
  };
  const onEndYearChange = (v: number) => {
    setFilters((s) => ({
      ...s,
      year: {
        ...s.year,
        end: v
      }
    }));
  };
  const onChangeSpecificCountry = (country: string[]) => {
    setFilters((s) => ({ ...s, contries: country }));
  };

  const onEcosystemChange = (value: number[]) => {
    setFilters((s) => ({ ...s, ecosystem: value }));
  };

  const onAnomalyRatingChange = (value: number[]) => {
    setFilters((s) => ({ ...s, anomalyRating: value }));
  };

  const onLocationChange = (value: 'unknown' | 'all') => {
    setFilters((s) => ({
      ...s,
      location: value === 'all' ? undefined : 0
    }));
  };

  const fetchDUMEvent = lDEQa(AxiosInstanceGlobalEvent(''));
  const onApply = () => {
    AdvanceFilterStore.filters = filters;
    setTimeout(() => {
      DUMEventStore.getDUMEvent(fetchDUMEvent);
      AdvanceFilterStore.show = false;
    }, 100);
  };

  useEffect(() => {
    setMinMaxYear([
      AdvanceFilterStore.allYears[0],
      AdvanceFilterStore.allYears[AdvanceFilterStore.allYears.length - 1]
    ]);
  }, [AdvanceFilterStore.allYears]);

  useEffect(() => {
    if (
      AdvanceFilterStore.filters.anomalyRating?.some(
        (v) => v !== undefined && v !== -1
      )
    ) {
      setShowAnomalyCard(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    filters,
    showAnomalyCard,
    setShowAnomalyCard,
    onChangeSpecificCountry,
    onEcosystemChange,
    onStartYearChange,
    onEndYearChange,
    onLocationChange,
    onApply,
    minMaxYear,
    onAnomalyRatingChange
  };
};

export default useAdvanceFilter;
